import React, { useState } from 'react';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Toolbar, Divider, Collapse } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GroupIcon from '@mui/icons-material/Group';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';

const Sidebar = ({ isOpen }) => {
    const navigate = useNavigate();
    const [openSales, setOpenSales] = useState(false); // 매출현황 하위 메뉴 열림 상태
    const [openSubscriptions, setOpenSubscriptions] = useState(false); // 유저 하위 메뉴 열림 상태
    const [openUsers, setOpenUsers] = useState(false); // 유저 하위 메뉴 열림 상태
    const [openPartners, setOpenPartners] = useState(false); // 파트너 하위 메뉴 열림 상태

    const handleSalesClick = () => {
        setOpenSales(!openSales); // 하위 메뉴 열기/닫기 토글
    };

    const handleSubscriptionsClick = () => {
        setOpenSubscriptions(!openSubscriptions); // 하위 메뉴 열기/닫기 토글
    };
    const handleUsersClick = () => {
    setOpenUsers(!openUsers); // 하위 메뉴 열기/닫기 토글
    };
    const handlePartnerssClick = () => {
        setOpenPartners(!openPartners); // 하위 메뉴 열기/닫기 토글
    };
    return (
        <Drawer
            variant="persistent"
            open={isOpen}
            anchor="left"
            sx={{
                width: isOpen ? 240 : 0,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: 240,
                    boxSizing: 'border-box',
                    transition: 'width 0.3s',
                },
            }}
        >
            <Toolbar />
            <Divider />
            <List>
                {/*/!* Dashboard *!/*/}
                {/*<ListItem button onClick={() => navigate('/')}>*/}
                {/*    <ListItemIcon>*/}
                {/*        <DashboardIcon />*/}
                {/*    </ListItemIcon>*/}
                {/*    <ListItemText primary="Dashboard" />*/}
                {/*</ListItem>*/}

                {/* News */}
                <ListItem button onClick={() => navigate('/News')}>
                    <ListItemIcon>
                        <GroupIcon />
                    </ListItemIcon>
                    <ListItemText primary="News Room" />
                </ListItem>
                {/* Users */}
                <ListItem button onClick={handleUsersClick}>
                    <ListItemIcon>
                        <GroupIcon />
                    </ListItemIcon>
                    <ListItemText primary="회원" />
                    {openUsers ? <ExpandLess /> : <ExpandMore />}
                </ListItem>

                {/* 회원 하위 메뉴 */}
                <Collapse in={openUsers} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem button sx={{ pl: 4 }} onClick={() => navigate('/user/detail')}>
                            <ListItemText primary="회원 조회" />
                        </ListItem>
                        <ListItem button sx={{ pl: 4 }} onClick={() => navigate('/users/hierarchy')}>
                            <ListItemText primary="회원 계보" />
                        </ListItem>
                    </List>
                </Collapse>

                <ListItem button onClick={handlePartnerssClick}>
                    <ListItemIcon>
                        <GroupIcon />
                    </ListItemIcon>
                    <ListItemText primary="Partners" />
                    {openPartners ? <ExpandLess /> : <ExpandMore />}
                </ListItem>

                {/* Partners 하위 메뉴 */}
                <Collapse in={openPartners} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem button sx={{ pl: 4 }} onClick={() => navigate('/partners')}>
                            <ListItemText primary="파트너요청 승인" />
                        </ListItem>
                        <ListItem button sx={{ pl: 4 }} onClick={() => navigate('/partners/candidate')}>
                            <ListItemText primary="파트너 후보 조회" />
                        </ListItem>
                    </List>
                </Collapse>

                {/* Items */}
                <ListItem button onClick={() => navigate('/items')}>
                    <ListItemIcon>
                        <GroupIcon />
                    </ListItemIcon>
                    <ListItemText primary="상품 리스트" />
                </ListItem>

                {/* Items */}
                {/*<ListItem button onClick={() => navigate('/item/modify')}>*/}
                {/*    <ListItemIcon>*/}
                {/*        <GroupIcon />*/}
                {/*    </ListItemIcon>*/}
                {/*    <ListItemText primary="상품 등록" />*/}
                {/*</ListItem>*/}

                {/* 무통장입금확인 */}
                <ListItem button onClick={() => navigate('/deposit')}>
                    <ListItemIcon>
                        <GroupIcon />
                    </ListItemIcon>
                    <ListItemText primary="무통장입금확인" />
                </ListItem>

                {/* 주문배송처리 */}
                <ListItem button onClick={() => navigate('/orders')}>
                    <ListItemIcon>
                        <GroupIcon />
                    </ListItemIcon>
                    <ListItemText primary="주문배송처리" />
                </ListItem>

                {/* 구독 (subs) */}
                <ListItem button onClick={handleSubscriptionsClick}>
                    <ListItemIcon>
                        <GroupIcon />
                    </ListItemIcon>
                    <ListItemText primary="구독" />
                    {openSubscriptions ? <ExpandLess /> : <ExpandMore />}
                </ListItem>

                {/*   구독 하위 메뉴 */}
                <Collapse in={openSubscriptions} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem button sx={{ pl: 4 }} onClick={() => navigate('/subscription/sub-cate')}>
                            <ListItemText primary="구독신청 관리" />
                        </ListItem>
                        <ListItem button sx={{ pl: 4 }} onClick={() => navigate('/subscriptions')}>
                            <ListItemText primary="진행중 구독리스트" />
                        </ListItem>
                        <ListItem button sx={{ pl: 4 }} onClick={() => navigate('/subsordercancel')}>
                            <ListItemText primary="구독취소 승인" />
                        </ListItem>
                        <ListItem button sx={{ pl: 4 }} onClick={() => navigate('/subscription/payments')}>
                            <ListItemText primary="구독 결제리스트" />
                        </ListItem>
                        <ListItem button sx={{ pl: 4 }} onClick={() => navigate('/subscription/payment-failures')}>
                            <ListItemText primary="구독 결제실패리스트" />
                        </ListItem>
                        <ListItem button sx={{ pl: 4 }} onClick={() => navigate('/subscription/speedcash')}>
                            <ListItemText primary="구독 스피드캐쉬" />
                        </ListItem>
                        <ListItem button sx={{ pl: 4 }} onClick={() => navigate('/subscription/director-allowance')}>
                            <ListItemText primary="국장 수당" />
                        </ListItem>
                        <ListItem button sx={{ pl: 4 }} onClick={() => navigate('/subscription/billing-jobs')}>
                            <ListItemText primary="정기결제 현황" />
                        </ListItem>
                    </List>
                </Collapse>

                {/* 렌트카 신청처리 */}
                <ListItem button onClick={() => navigate('/rentcar')}>
                    <ListItemIcon>
                        <GroupIcon />
                    </ListItemIcon>
                    <ListItemText primary="렌트카승인" />
                </ListItem>

                {/* 매출현황 (Sales) */}
                <ListItem button onClick={handleSalesClick}>
                    <ListItemIcon>
                        <GroupIcon />
                    </ListItemIcon>
                    <ListItemText primary="매출현황" />
                    {openSales ? <ExpandLess /> : <ExpandMore />}
                </ListItem>

                {/* 매출현황 하위 메뉴 */}
                <Collapse in={openSales} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem button sx={{ pl: 4 }} onClick={() => navigate('/sales/subs')}>
                            <ListItemText primary="구독 매출" />
                        </ListItem>
                        <ListItem button sx={{ pl: 4 }} onClick={() => navigate('/sales/valie')}>
                            <ListItemText primary="코노미몰 매출" />
                        </ListItem>
                        <ListItem button sx={{ pl: 4 }} onClick={() => navigate('/sales/transactions')}>
                            <ListItemText primary="주문 리스트" />
                        </ListItem>
                    </List>
                </Collapse>

                {/* 리워드 */}
                {/*<ListItem button onClick={() => navigate('/rewards')}>*/}
                {/*    <ListItemIcon>*/}
                {/*        <GroupIcon />*/}
                {/*    </ListItemIcon>*/}
                {/*    <ListItemText primary="리워드" />*/}
                {/*</ListItem>*/}

                {/* 정기결제 수동 */}
                <ListItem button onClick={() => navigate('/billing')}>
                    <ListItemIcon>
                        <GroupIcon />
                    </ListItemIcon>
                    <ListItemText primary="정기결제 수동" />
                </ListItem>
            </List>
        </Drawer>
    );
};

export default Sidebar;